<mat-checkbox (keydown.enter)="bestellerinnerungSchreiben($event)" (click)="bestellerinnerungSchreiben($event)" [checked]="checked" tabindex="0">
  Ich möchte die Bestellerinnerung nutzen.
</mat-checkbox>
